var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.phases,"multiple":_vm.multiple,"label":_vm.multiple
            ? _vm.$localize('ProjectOverview.phases')
            : _vm.$localize('ProjectOverview.phase')},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }